module.exports = __webpack_public_path__ + "assets/images/skai_hybrid.583c4bb310e9221876adcf815ba9deb7.png";